import { envConfig } from "./envConfig";

const zuoraRoot = envConfig.ZuoraDomain;

const zuoraSubscriptions = `${zuoraRoot}/apps/Subscription.do?method=view&subscriptionNumber=`;

export const ZuoraUriMap = {
  zuoraRoot,
  zuoraSubscriptions,
};
